import { ReactNode } from 'react';

import { alpha, Drawer } from '@mui/material';

import { SDialog } from './styled';

type PaywallDialogProps = {
  children: ReactNode;
  isMobile: boolean;
  isOpen: boolean;
  // `<testId>-dialog` on desktop, `<testId>-drawer` on mobile.
  testId: string;
  onClose: () => void;
};

// Shows a PaywallCard as a centred modal, or as a bottom sheet on phones (give the card the `sheet` layout there).
export const PaywallDialog = ({ children, isMobile, isOpen, testId, onClose }: PaywallDialogProps) => {
  if (isMobile) {
    return (
      <Drawer
        PaperProps={{
          sx: {
            backgroundColor: 'transparent',
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            boxShadow: 'none',
          },
        }}
        sx={(theme) => ({
          '& .MuiBackdrop-root': { backdropFilter: 'blur(3px)', backgroundColor: alpha(theme.palette.grey[900], 0.45) },
        })}
        anchor="bottom"
        data-testid={`${testId}-drawer`}
        open={isOpen}
        onClose={onClose}
      >
        {children}
      </Drawer>
    );
  }

  return (
    <SDialog data-testid={`${testId}-dialog`} open={isOpen} onClose={onClose}>
      {children}
    </SDialog>
  );
};
